<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加系統公告</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">

						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索標題"></el-input>
						</el-form-item>

						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.notice_no" placeholder="搜索編號"></el-input>
						</el-form-item>
						
						<el-form-item label="內容" class="mb-0">
							<el-input size="small" v-model="from.content" placeholder="搜索內容"></el-input>
						</el-form-item>
						
						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="機構發送" :value="3"></el-option>
								<el-option label="後台發送" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="發送對象" class="mb-0">
							<el-select v-model="from.sendtype" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="全部人" :value="0"></el-option>
								<el-option label="學校" :value="1"></el-option>
								<el-option label="機構" :value="2"></el-option>
								<el-option label="學生" :value="3"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="待審核" :value="0"></el-option>
								<el-option label="通過" :value="1"></el-option>
								<el-option label="拒絕" :value="2"></el-option>
							</el-select>
						</el-form-item>
					
						<el-form-item label="發送時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>

				<el-table-column align="center" prop="sort" label="排序" width="100" sortable="custom" :default-sort="{prop: 'sort', order: 'descending'}">
					<template slot-scope="scope">
						<el-button 
							type="text" 
							@click="openSortDialog(scope.row)"
							style="color: #409EFF;"
						>
							{{ scope.row.sort || 0 }}
						</el-button>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="notice_no" width="120" label="編號">
				</el-table-column>
			
						
				<el-table-column align="center" prop="title" label="發送標題">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 15">
										{{ scope.row.title.substring(0, 15) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
					</el-table-column>

				<el-table-column align="center" width="80" prop="content" label="公告內容">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope.row)">
								<el-tag size="medium">查看</el-tag>
							</div>
						</template>
				</el-table-column>
				
				
				<el-table-column align="center"  prop="type"  label="類型">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.type==2">後台發送 - {{v.row.send_name}}</span>
						<span class="text-warning" v-if="v.row.type==3">機構發送 - {{v.row.send_name}}</span>
					</template>
				</el-table-column>

				
				<el-table-column align="center" width="200"  prop="status"  label="發送類型">
					<template slot-scope="v">
						<span v-if="v.row.sendtype==0">全部</span>
						<span v-if="v.row.sendtype==1">
							<span v-if="v.row.appoint_id==0">全部學校</span>
							<span v-if="v.row.appoint_id!=0">
								指定學校 - <el-tag type="warning">{{v.row.user.name}}</el-tag>
							</span>
						</span>
						<span v-if="v.row.sendtype==2">
							<span v-if="v.row.appoint_id==0">全部機構</span>
							<span v-if="v.row.appoint_id!=0">
								指定機構- <el-tag type="warning">{{v.row.user.name}}</el-tag>
							</span>
						</span>
						<span v-if="v.row.sendtype==3">
							<span v-if="v.row.com_user_id==0">全部學生</span>
							<span v-if="v.row.com_user_id!=0">
								指定比賽 - <el-tag type="warning">{{v.row.user.name}}</el-tag>
							</span>
						</span>
						
					</template>
				</el-table-column>
				<el-table-column align="center" width="80" prop="is_show" label="登錄狀態" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.is_show ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeStatus(scope.row,2)"
						plain>{{scope.row.is_show ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
				
				<!-- 				
				<el-table-column align="center"   prop="status"  label="總人數 / 已读">
					<template slot-scope="v">
						{{v.row.total}} / {{v.row.readnum}}
					</template>
				</el-table-column>
				 -->
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 	-->
				
				<el-table-column align="center" prop="create_time" width="170" label="發送時間">
				</el-table-column>
				
				<el-table-column align="center" prop="endTime" width="110" label="張貼日期至">
				</el-table-column>

				<el-table-column align="center" prop="status" width="100" label="狀態">
					<template slot-scope="v">
						<span class="text-warning" v-if="v.row.status==0">待審核</span>
						<span class="text-success" v-if="v.row.status==1">通過</span>
						<span class="text-danger" v-if="v.row.status==2">拒絕</span>
					</template>
				</el-table-column>	
				<el-table-column align="center" prop="read_num" width="110" label="閱讀人數">
				</el-table-column>

				<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="200" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
							<el-button @click="notice_look(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="warning">預覽</el-button>
						</el-button-group>
					</template>
				</el-table-column>
				
			</el-table>
		</div>

		<el-dialog :close-on-click-modal="false" top="5vh" :visible.sync="dialogVisible" :width="layout.is_phone?'90%':'70%'" @close="closeDialog">
			<span slot="title">
				<span style="font-size: 2em;">{{ dialogTitle }}</span>
				<div class="dialog-meta" style="margin-bottom: 10px;">
				<p>
					<span class="text-success" v-if="dialogArr.type==2">後台發送 - {{dialogArr.send_name}}</span>
					<span class="text-warning" v-if="dialogArr.type==3">機構發送 - {{dialogArr.send_name}}</span><strong style="margin-left: 40px;">{{ dialogArr.staTime }}</strong> </p>
				
				<p>{{ dialogArr.msg }}</p>
			</div>
			</span>
			<div ref="dialogContent" style="max-height: 70vh; overflow: auto;">
				
			
						<!-- 使用 v-html 渲染 HTML 内容 -->
						<div v-html="dialogContent"></div>
					</div>
						<span slot="footer" class="dialog-footer" >
							<el-button @click="closeDialog">關閉</el-button>
						</span>
				
					</el-dialog>
		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加系統公告':'修改系统公告'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單內容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				<el-form-item  label="圖片" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'4',cms_type:'3'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.icon" :src="form.icon" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<span style="color: red;">圖片比例為 1*1 的正方形</span>
				</el-form-item>

				<el-form-item  label="二維碼圖片" prop="qrurl" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'4',cms_type:'3'}"
					  :show-file-list="false"
					  :on-success="handleQrcodeSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.qrurl" :src="form.qrurl" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<span style="color: red;">請上傳二維碼圖片</span>
				</el-form-item>

				<el-form-item label="到期日期" size="small" prop="endTime">
							
							<el-date-picker
										v-model="form.endTime"
										value-format="yyyy-MM-dd"
										type="date"
										placeholder="選擇日期"
										:picker-options="pickerOptionss"
										>
										</el-date-picker>

						</el-form-item>

				<el-form-item label="公告類型"   prop="com_type">
					<el-radio-group v-model="form.com_type" :disabled="editIndex>0?true:false">
					    <el-radio :label="0">正常公告</el-radio>
					    <el-radio :label="1">比賽公告</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item v-show="form.com_type == 1" label="選擇比賽" prop="user_id">
					<el-select
						 size="small" style="width: 85%;"
						v-model="form.com_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:比賽編號 - 機構 - 比賽標題"
						:remote-method="remoteMethod"
						:loading="loading">
						<el-option
						v-for="item in ComOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="發送對象"   prop="sendtype" v-show="form.com_type == 0">
					<el-radio-group v-model="form.sendtype" :disabled="editIndex>0?true:false">
					    <el-radio :label="0">全部</el-radio>
					    <el-radio :label="1">學校</el-radio>
					    <el-radio :label="2">機構</el-radio>
						<el-radio :label="3">學生</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				<el-form-item  label="發送類型"  v-show="form.sendtype==1 && form.com_type == 0"  prop="sendtype">
					
					 <el-radio-group @change="changeType" v-model="form.all_type" :disabled="editIndex>0?true:false">
					    <el-radio :label="0">全部</el-radio>
					    <el-radio :label="1">指定學校</el-radio>
					</el-radio-group>
					 
				</el-form-item>
				
				<el-form-item  label="發送類型"  v-show="form.sendtype==2 && form.com_type == 0"  prop="sendtype">
					
					 <el-radio-group @change="changeType" v-model="form.all_type" :disabled="editIndex>0?true:false">
					    <el-radio :label="0">全部</el-radio>
					    <el-radio :label="1">指定機構</el-radio>
					  </el-radio-group>
				</el-form-item>
				
				<el-form-item  label="發送類型"  v-show="form.sendtype==3 && form.com_type == 0"  prop="sendtype">
					 <el-radio-group @change="changeType" v-model="form.all_type" :disabled="editIndex>0?true:false">
					     <el-radio :label="0">全部</el-radio>
					     <el-radio :label="1">比賽</el-radio>
					 </el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="editIndex<0" v-show="form.sendtype==1 && form.all_type==1 && form.com_type == 0" label="選擇學校" prop="school_id">
					<el-select
						size="small" style="width: 85%;"
						v-model="form.school_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:學校編號 - 學校地區 - 學校名稱"
						:remote-method="remoteMethodSchool"
						:loading="loading">
						<el-option
						v-for="item in schoolOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
					
				</el-form-item>
				
				<el-form-item  v-show="form.sendtype==2 && form.all_type==1 && form.com_type == 0" label="選擇機構" prop="ins_id">
					<el-select
						size="small" style="width: 85%;"
						v-model="form.ins_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:機構名稱 - 機構賬號"
						:remote-method="remoteInMethod"
						:loading="loading">
						<el-option
						v-for="item in InsOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item v-if="editIndex<0" v-show="form.sendtype==3 && form.all_type==1 && form.com_type == 0" label="選擇比賽" prop="user_id">
					<el-select
						 size="small" style="width: 85%;"
						v-model="form.user_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:比賽編號 - 機構 - 比賽標題"
						:remote-method="remoteMethod"
						:loading="loading">
						<el-option
						v-for="item in ComOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			
				<el-form-item label="發送標題" prop="title">
					<el-input type="text" v-model="form.title" 
					placeholder="發送標題" 
					maxlength="60"
					show-word-limit  
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>


				<el-form-item label="簡介" prop="msg">
					<el-input type="text" v-model="form.msg" 
					placeholder="簡介" 
					maxlength="100"
					show-word-limit  
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item  label="發送內容" prop="content">
					<quill-editor ref="text" v-model="form.content" style="width: 85%;height: 300px;padding-bottom: 60px;" :options="editorOptions"/>
				</el-form-item>

				<el-form-item label="審核狀態" prop="status" v-if="form.type == 3">
					<el-radio-group v-model="form.status" >
					    <el-radio :label="1">通過</el-radio>
					    <el-radio :label="2">拒絕</el-radio>
					</el-radio-group>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="發送標題">
			<p>{{ fullTitle }}</p>
		</el-dialog>

		<!-- 修改排序彈窗 -->
		<el-dialog :close-on-click-modal="false" title="修改排序" :visible.sync="sortDialogVisible" width="400px">
			<el-form :model="sortForm" label-width="100px">
				<el-form-item label="當前排序">
					<span>{{ sortForm.old_sort || 0 }}</span>
				</el-form-item>
				<el-form-item label="新排序" required>
					<el-input-number 
						v-model="sortForm.sort" 
						:min="1" 
						:max="9999"
						style="width: 100%;"
					></el-input-number>
					<div style="color: #909399; font-size: 12px; margin-top: 5px;">
						提示：修改排序後，其他記錄會自動調整
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="sortDialogVisible = false">取 消</el-button>
				<el-button type="primary" :loading="sortLoading" @click="handleSortChange">確 定</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"  title="預覽" :visible.sync="noticeLook" 
		top="5vh" :width="layout.is_phone?'90%':'50%'" >
			<!-- 动态背景 -->
			<div :style="dynamicStyle" class="preview-container">
				<div v-if="noticeType == 2" style="margin-top: 20px;width: 273px;max-height: 600px;overflow-y: auto;padding-right: 10px;">
					<div style="font-size: 20px;font-weight: 700;color:black;word-break: break-word; white-space: normal;border-top: 1px solid black; border-bottom: 1px solid black; padding: 1px; margin-bottom: 10px;">{{noticeLookData.title}}</div>
					<div style="padding: 5px 11px;font-size: 14px;font-weight: 700;color:red;word-break: break-word; white-space: normal;">{{noticeLookData.com_title}}</div>
				</div>
				<div v-if="noticeType == 3" style="margin-top: 142px;width: 273px;max-height: 600px;overflow-y: auto;padding-right: 10px;">
					<div style="font-size: 20px;font-weight: 700;color:blue;word-break: break-word; white-space: normal;">{{noticeLookData.title}}</div>
					<div v-html="noticeLookData.content" style="text-align: left; word-break: break-word; white-space: normal;word-break: break-word;white-space: normal;text-indent: 2em;line-height: 1.6;" class="content-text"></div>
				</div>
				<div v-if="noticeType == 1" style="margin-top: 200px;width: 273px;max-height: 600px;overflow-y: auto;padding-right: 10px;">
					<div style="font-size: 20px;font-weight: 700;color:blue;word-break: break-word; white-space: normal;">{{noticeLookData.title}}</div>
					<div v-html="noticeLookData.content" style="text-align: left; word-break: break-word; white-space: normal;word-break: break-word;white-space: normal;text-indent: 2em;line-height: 1.6;" class="content-text"></div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="noticeLook = false">關 閉</el-button>
			</div>
		</el-dialog>
	
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogTitleVisible: false,
				fullTitle: '',
				dialogTitle:'',
				editorOptions: {
					modules: {
						toolbar: [
							[{ header: [1, 2, false] }], // 標題选项
							['bold', 'italic', 'underline','image','indent','clean'], // 粗体、斜体、下划线
						]
					},
					placeholder: '請填寫發送內容'  // 设置占位符
				},
				pickerOptionss: {
					disabledDate(time) {
						return time.getTime() < Date.now();
					}
				},
				schoolOptions: [],
				rules: {
					title: [{
							required: true,
							message: "標題不能為空",
							trigger: 'blur',
						},
					],
					content: [{
							required: true,
							message: "內容不能為空",
							trigger: 'blur',
						},
					],
					msg: [{
							required: true,
							message: "簡介不能為空",
							trigger: 'blur',
						},
					],
					status: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.type === 3 && !value) {
								callback(new Error("請選擇审核狀態"));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					school_id: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.sendtype === 1 && this.form.all_type === 1 && !value) {
								callback(new Error("請選擇學校"));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					ins_id: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.sendtype === 2 && this.form.all_type === 1 && !value) {
								callback(new Error("請選擇機構"));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					endTime: [{
							required: true,
							message: "請選擇到期時間",
							trigger: 'blur',
						},
					],
					// user_id: [{
					// 	required: true,
					// 	validator: (rule, value, callback) => {
					// 		if (this.form.sendtype === 3 && this.form.all_type === 1 && !value) {
					// 			callback(new Error("請選擇學生"));
					// 		} else {
					// 			callback();
					// 		}
					// 	},
					// 	trigger: 'change'
					// }],
					com_id: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.com_type === 1 && !value) {
								callback(new Error("請選擇比賽"));
							} else {
								callback();
							}
						},
						trigger: 'change'
					}],
					
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					content:'',
					msg:'',
					notice_no:'',
					type:-1,
					all_type:-1,
					ins_type:-1,
					status:-1,
					sendtype:-1,
					
					time: [],
				},
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/noticeList", //列表地址
				addUrl: "data/addNotice", //添加/修改地址
				delAllUrl: "data/delNoticeAll", //批量删除地址
				delUrl: "data/delNotice", //删除單条地址
				editStatusUrl: "data/editStatusNotice", //修改狀態地址
				updateSortUrl: "data/updateNoticeSort", //修改排序地址
				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
					msg:'',
					endTime:'',
					sendtype:0,
					user_id:null,
					ins_id:null,
					ins_type:0,
					all_type:0,
					school_id:null,
					com_type:0,
					status:0,
					com_id:'',
					icon:'',
					qrurl:'',
				},
				prop: 'sort',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				ComOptions: [],
				InsOptions: [],
				com_list: [],

				
				loading: false,      
				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容
				dialogTitle: '' ,         // 存储當前对话框的標題
				dialogArr:[],

				submitLoading:false,

				noticeLook:false,
				noticeType:1,
				noticeLookData:[],

				// 排序相關
				sortDialogVisible: false,
				sortLoading: false,
				sortForm: {
					id: 0,
					sort: 1,
					old_sort: 0,
				},
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
			dynamicStyle() {
				return {
					backgroundImage: `url(${this.noticeLookData.backgroundImage})`,
					// backgroundImage: `url(${require(`${this.noticeLookData.backgroundImage}`)})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					width: '375px',
					height: '667px', // 这里可以根据实际情况调整
					display: 'flex',
					justifyContent: 'center'
				};
			}
		},
		created() {
			this.commonList(['inst_list','com_list']);
		},
		methods: {
			notice_look(res){
				this.noticeLook = true;
				this.noticeLookData = res;
				this.noticeType = 1;
				this.noticeLookData.backgroundImage = require('@/assets/WechatIMG30251.jpg');
				if(this.noticeLookData.is_result > 0){
					this.noticeType = 2;
					this.noticeLookData.backgroundImage = require('@/assets/WechatIMG30253.jpg');
				}
				if(this.noticeLookData.com_id > 0){
					this.noticeType = 3;
					this.noticeLookData.backgroundImage = require('@/assets/WechatIMG30252.jpg');
				}
				
			},
			remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getComOptionList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.ComOptions = all.data.list;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.ComOptions = [];
						this.loading = false;
					})
				} else {
					this.ComOptions = [];
					this.loading = false;
				}
			},
			remoteInMethod(query) {
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getInsList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.InsOptions = all.data.list;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.InsOptions = [];
						this.loading = false;
					})
				} else {
					this.InsOptions = [];
					this.loading = false;
				}
			},
			openDialog(row) {
				this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				this.dialogTitle = row.title; // 设置要顯示的 HTML 内容
				this.dialogArr = row; // 设置要顯示的 HTML 内容
				this.dialogVisible = true;    // 顯示对话框
				
			},
			changeType(){
				if(this.form.sendtype==2){
					if(this.form.all_type==1){
						
					}
				}
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
				this.dialogArr = [];      // 清空内容
			},
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.inst_list = list.inslist
					this.com_list = list.com_list
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {
				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			remoteMethodSchool(query){
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getSchoolList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.schoolOptions = all.data;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.schoolOptions = [];
						this.loading = false;
					})
				} else {
					this.schoolOptions = [];
					this.loading = false;
				}
			},
			//提交
			submit() {
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.submitLoading = true;
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.logo = res.encryption.data.list.url
				}
			  },
			
			handleQrcodeSuccess(res, file) {
				this.form.qrurl = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.qr_url = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 20;
		
				if (!isJPG) {
				  this.$message.error('上傳头像圖片只能是 JPG 格式!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳头像圖片大小不能超過 20MB!');
				}
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						title: e.title,
						content: e.content,
						msg: e.msg,
						sendtype:e.sendtype,
						school_id:Number(e.appoint_id),
						ins_id:Number(e.appoint_id),
						user_id:Number(e.appoint_id),
						ins_type:e.ins_type,
						all_type:e.all_type,
						com_id:e.com_id,
						endTime:e.endTime,
						status:e.status,
						type:e.type,
						com_type:e.com_type,
						icon:e.logo,
						qrurl:e.qr_url || '',
					}
					this.editIndex = e.id
					
					this.remoteMethod(e.com_t)
					if(this.form.sendtype==2){
						if(this.form.all_type==1){
							if(this.form.ins_type==1){
								this.sel_ins = this.ins_1
							}else if(this.form.ins_type==2){
								this.sel_ins = this.ins_2
							}else{
								this.sel_ins = this.ins_list
							}
						}
					}
					
					
				}else{
					this.form = {
						id: 0,
						title:'',
						content:"",
						msg:'',
						endTime:'',
						sendtype:0,
						school_id:null,
						ins_id:null,
						user_id:null,
						ins_type:0,
						all_type:0,
						com_type:0,
						com_type:0,
						com_id:'',
						icon:'',
						qr_url:'',
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list.map(item => {
					// 保存原始排序值，用於排序變更時比較
					if (!item.old_sort) {
						item.old_sort = item.sort || 0;
					}
					return item;
				})
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					content:'',
					notice_no:'',
					type:-1,
					all_type:-1,
					status:-1,
					ins_type:-1,
					sendtype:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇圖片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			},
			
			// 打開排序修改彈窗
			openSortDialog(row) {
				this.sortForm = {
					id: row.id,
					sort: row.sort || 0,
					old_sort: row.sort || 0,
				};
				this.sortDialogVisible = true;
			},
			
			// 處理排序變更
			handleSortChange() {
				if (!this.sortForm.sort || this.sortForm.sort < 1) {
					this.$message.error('排序值必須大於0');
					return;
				}
				
				if (this.sortForm.sort == this.sortForm.old_sort) {
					this.$message.warning('排序值未改變');
					this.sortDialogVisible = false;
					return;
				}
				
				this.sortLoading = true;
				
				this.axios.post('/admin/' + this.updateSortUrl, {
					id: this.sortForm.id,
					sort: this.sortForm.sort,
					old_sort: this.sortForm.old_sort
				}, {
					token: true,
				}).then(res => {
					this.$message.success('排序更新成功');
					this.sortDialogVisible = false;
					this.getList();
				}).catch(err => {
					this.$message.error('排序更新失敗');
				}).finally(() => {
					this.sortLoading = false;
				})
			}
		}
	}
</script>

<style>
	.ql-toolbar {
		display: flex;
		flex-wrap: wrap;  /* 確保工具栏中的元素能够自动换行 */
		align-items: center;  /* 对齐工具栏内的按钮 */
		justify-content: flex-start;
	}
	.ql-snow .ql-picker-label::before{
		position: absolute;
	}
	.ql-toolbar .ql-formats {
		margin-right: 10px;  /* 调整工具栏按钮之間的間距 */
	}
	.ql-snow .ql-picker svg {
		position: absolute;
    top: 1px;
}
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .dialog-content img {
  max-width: 100%;
  max-height: 80vh; /* 根据需要调整这个值，防止图片超出视窗高度 */
  object-fit: contain;
}
.dialog-contents{
	max-height: 500px;
    overflow-y: auto;
}
.dialog-meta p {
  margin: 0;
  line-height: 1.5;
}
.dialog-meta p strong {
  margin-right: 5px;
}
.text-success {
  color: green;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
.el-dialog__body{
	padding-top: 5px;
}
.preview-container {
    padding: 20px;
    border-radius: 10px;
    text-align: center;
	margin: 0 auto;
}

.image-layout .preview-image {
    max-width: 100%;
    height: auto;
    border-radius: 10px;
}

.text-layout .preview-text {
    font-size: 16px;
    color: #333;
}

.video-layout .preview-video {
    max-width: 100%;
    border-radius: 10px;
}

.default-layout .default-text {
    font-size: 16px;
    color: #999;
}
.content-text p {
    margin: 0;
    padding: 0;
    text-indent: 2em;  /* 确保每个段落的首行都缩进 */
}
</style>

